import { makeSelectors } from '@utils/css';

const tableModifiers = makeSelectors({
  new: "_275nlwaym1"
});
const tableCls = "_275tspy6p9";

export { tableCls, tableModifiers };
import "./shared.table.style.linaria.module.css";
//# sourceMappingURL=shared.table.style.js.map
